import { jsx as m } from "react/jsx-runtime";
import { d as n } from "../../../vendor-EQDp64ng.js";
import "react";
import { getSpacingClasses as a } from "../../../utils/getSpacingClasses/index.js";
import '../../../assets/index20.css';const l = "_footer_kvk1l_1", p = "_sticky_kvk1l_10", o = {
  footer: l,
  sticky: p
};
function u({ children: t, sticky: s, p: r, pt: c, pr: e, pb: i, pl: f }) {
  const k = n(o.footer, s && o.sticky, a({ p: r, pb: i, pl: f, pr: e, pt: c }));
  return /* @__PURE__ */ m("footer", { className: k, children: t });
}
export {
  u as Footer
};
